document.addEventListener('DOMContentLoaded', function() {
  let originalTitle = document.title;
  
  // Get the template type from the data attribute on main element
  let template = document.querySelector('main[data-template]');
  let templateType = template ? template.getAttribute('data-template') : '';
  
  // Set different messages based on template
  let notificationTitle;
  if (templateType.includes('product')) {
    notificationTitle = "🔥 Hurry, these are selling fast!";
  } else if (templateType.includes('cart')) {
    notificationTitle = "🔥 Hurry, don't lose your cart!";
  } else if (templateType.includes('collection')) {
    notificationTitle = "🔥 Hurry, stock is selling fast!";
  } else {
    notificationTitle = "🔥 Hurry! stock is selling fast!";
  }
  
  let isTabActive = true;
  let titleInterval;

  console.log('Tab notification script loaded for template:', templateType);

  // Detect when user leaves/returns to tab
  document.addEventListener('visibilitychange', function() {
    console.log('Visibility changed, hidden:', document.hidden);
    
    if (document.hidden) {
      // User left the tab - start flashing
      isTabActive = false;
      startTitleFlash();
    } else {
      // User returned to tab - stop flashing
      isTabActive = true;
      stopTitleFlash();
    }
  });

  function startTitleFlash() {
    let showNotification = true;
    console.log('Starting title flash with message:', notificationTitle);
    
    titleInterval = setInterval(function() {
      document.title = showNotification ? notificationTitle : originalTitle;
      showNotification = !showNotification;
    }, 750);
  }

  function stopTitleFlash() {
    console.log('Stopping title flash');
    clearInterval(titleInterval);
    document.title = originalTitle;
  }

});